
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moderate",
      function () {
        return require("private-next-pages/moderate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moderate"])
      });
    }
  